import { exportTableToPdf } from '../exportTableToPdf';
import { getActionLogPdfCellStyle, ACTION_LOG_BADGE_COLUMNS } from '../pdfCellStyles';
import {
    filterRowsByIds,
    formatPdfDate,
    formatPdfDateTime,
    formatPlainText,
    getVisibleColumnsFromOrder,
} from '../pdfTextUtils';

export const ACTION_LOG_COLUMN_LABELS = {
    action: 'Action',
    owner: 'Owner',
    dueDate: 'Due date',
    status: 'Status',
    workstream: 'Workstream',
    source: 'Source',
    actionTaken: 'Action Taken',
    loggedOn: 'Logged on',
    updatedOn: 'Updated on',
};

const ACTION_LOG_STATUS_LABELS = {
    NOT_STARTED: 'Not Started',
    WORKING_ON_IT: 'Working on it',
    COMPLETED: 'Completed',
    STUCK: 'Stuck',
    CANCELLED: 'Cancelled',
};

const COLUMN_WEIGHTS = {
    action: 3.5,
    owner: 1.2,
    dueDate: 1.1,
    status: 1.1,
    workstream: 1.3,
    source: 1.1,
    actionTaken: 2,
    loggedOn: 1.2,
    updatedOn: 1.2,
};

const getCellValue = (row, columnKey) => {
    switch (columnKey) {
        case 'action':
            return formatPlainText(row.action_text || '');
        case 'owner':
            return formatPlainText(row.owner || '');
        case 'dueDate':
            return row.due_date ? formatPdfDate(row.due_date) : '-- --';
        case 'status':
            return ACTION_LOG_STATUS_LABELS[row.status] || row.status || '';
        case 'workstream':
            return formatPlainText(row.workstream_repr || '');
        case 'source':
            return formatPlainText(row.source_repr || '');
        case 'actionTaken':
            return formatPlainText(row.action_taken || '');
        case 'loggedOn':
            return row.created ? formatPdfDateTime(row.created) : '-- --';
        case 'updatedOn':
            return row.last_updated ? formatPdfDateTime(row.last_updated) : '-- --';
        default:
            return '';
    }
};

export const exportActionLogToPdf = async ({
    rows,
    groupedSections = null,
    columnOrder,
    isColumnVisible,
    projectName,
    selectedRowIds = null,
    filename = 'action_log.pdf',
}) => {
    const visibleColumns = getVisibleColumnsFromOrder(columnOrder, ACTION_LOG_COLUMN_LABELS, isColumnVisible);
    const filteredRows = filterRowsByIds(rows, selectedRowIds);

    const sections = groupedSections?.length
        ? groupedSections.map(section => ({
              title: `${section.groupName} (${section.items?.length || 0})`,
              rows: filterRowsByIds(section.items, selectedRowIds),
          }))
        : null;

    await exportTableToPdf({
        title: 'Action Log',
        projectName,
        visibleColumns,
        rows: sections ? [] : filteredRows,
        groupedSections: sections,
        getCellValue,
        getCellStyle: (row, columnKey) => getActionLogPdfCellStyle(columnKey, row),
        columnWeights: COLUMN_WEIGHTS,
        badgeColumns: ACTION_LOG_BADGE_COLUMNS,
        filename,
    });
};
